exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-loader[data-v-77695c06]{text-align:center;padding:35px 0}.full-loader p[data-v-77695c06]{margin-bottom:0;font-variant:small-caps;text-transform:lowercase}.full-loader p[data-v-77695c06]:after{content:\"...\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-77695c06","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/partials/FullLoader.vue
// module id = zjUQ
// module chunks = 1